// The card under a customer, supplier, job worker or Item LAMP drafted from the person's words (#502): Confirm records
// it as drafted; Correct opens the same form the pages use, filled in from the draft, and confirms it as corrected.
// Once recorded, the card says so and offers nothing more.
import { useState } from "react";
import type { MasterDataCard, MasterDataCorrections } from "../api.js";
import { useWords } from "../i18n/words.js";
import { MasterDataForm } from "../parties/MasterDataForm.js";

export function MasterDataCardView({
  card,
  busy,
  onConfirm,
}: {
  card: MasterDataCard;
  busy: boolean;
  /** Confirms the draft, with the person's corrections; throws the API's refusal. */
  onConfirm: (corrected?: MasterDataCorrections) => Promise<void>;
}) {
  const w = useWords();
  const [correcting, setCorrecting] = useState(false);
  if (card.status === "done") return <p className="small muted">{w.masterRecorded}</p>;
  const { record, action, ...fields } = card.draft;
  return (
    <div className="card">
      {correcting ? (
        <MasterDataForm
          record={record}
          editing={action === "correct"}
          initial={fields}
          submitLabel={w.masterConfirm}
          onSubmit={async (corrected, _kind, emptied) => {
            // The corrected draft whole: a field the person emptied is cleared, not kept as LAMP drafted it.
            await onConfirm({ ...corrected, ...Object.fromEntries(emptied.map((field) => [field, null])) });
            return undefined;
          }}
        />
      ) : (
        <div className="actions">
          <button type="button" className="btn" disabled={busy} onClick={() => void onConfirm().catch(() => undefined)}>
            {w.masterConfirm}
          </button>
          <button type="button" className="btn" disabled={busy} onClick={() => setCorrecting(true)}>
            {w.masterCorrect}
          </button>
        </div>
      )}
    </div>
  );
}
